import { defineFcm } from '../shared/factory';

export const FCM_HEADER_HIDE_BROWSE_LINK = defineFcm('header_hide_browse_link')
	.asBoolean()
	.withDefault(false)
	.toConfig();
